import { Routes, Route, Outlet } from 'react-router-dom';
import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';
import BookRepairPage from '@/pages/BookRepairPage';
import WarrantyPage from '@/pages/WarrantyPage';
import TermsPage from '@/pages/TermsPage';
import PrivacyPage from '@/pages/PrivacyPage';
import ContactPage from '@/pages/ContactPage';
import ExtendedWarrantyPage from '@/pages/ExtendedWarrantyPage';
import BrandPage from '@/pages/BrandPage';
import LocationsPage from '@/pages/LocationsPage';
import LegacyRedirect from '@/components/LegacyRedirect';
import LocationPage from '@/pages/LocationPage';
import LoginPage from '@/pages/LoginPage';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminApiConfig from '@/pages/admin/ApiConfig';
import AdminPayments from '@/pages/admin/Payments';
import AdminWebApp from '@/pages/admin/WebApp';
import AdminAddresses from '@/pages/admin/Addresses';
import AdminDiagnostics from '@/pages/admin/Diagnostics';
import AdminPageEditor from '@/pages/admin/PageEditor';
import AdminContentSEO from '@/pages/admin/ContentSEO';
import PrivacyBanner from '@/components/PrivacyBanner';
import AccessibilityWidget from '@/components/AccessibilityWidget';

export default function App() {
  return (
    <>
      <Routes>
      {/* Public routes */}
      <Route element={<Layout><Outlet /></Layout>}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/brands/:slug" element={<BrandPage />} />
        <Route path="/repair-enquiry" element={<BookRepairPage />} />
        <Route path="/warranty" element={<WarrantyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/extended-warranty" element={<ExtendedWarrantyPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/locations/:slug" element={<LocationPage />} />
        {/* Legacy WordPress URL redirects + custom 404 (must stay last) */}
        <Route path="*" element={<LegacyRedirect />} />
      </Route>

      {/* Login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin */}
      <Route element={<AdminLayout />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/api-config" element={<AdminApiConfig />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/webapp" element={<AdminWebApp />} />
        <Route path="/admin/addresses" element={<AdminAddresses />} />
        <Route path="/admin/diagnostics" element={<AdminDiagnostics />} />
        <Route path="/admin/page-editor" element={<AdminPageEditor />} />
        <Route path="/admin/content-seo" element={<AdminContentSEO />} />
      </Route>
    </Routes>
    <PrivacyBanner />
    <AccessibilityWidget />
    </>
  );
}